// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3I1pu","paramInput":"JobSimulator_paramInput__MNksp","input":"JobSimulator_input__1Q8YS"};